<template>
    <b-card no-body class="overflow-hidden">
        <b-overlay :show="getting" opacity="0.5">
            <div class="p-1">
                <div class="row align-items-center gy-50">
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{ m.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year">
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                        </select>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="branchType">
                            <option value="O">Org. Şube</option>
                            <option value="S">SGK Şube</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'O'">
                        <v-select-list append-to-body :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'S'">
                        <v-select-list append-to-body :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <v-select-list append-to-body :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <input placeholder="Ara..." class="form-control" v-model="search" v-on:keypress.enter="collarStatus != null ? get() : null" />
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" :disabled="collarStatus == null" v-on:click="get">Sorgula</button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-outline-success" :disabled="collarStatus == null || exporting" v-on:click="exportToExcel">
                            <b-spinner small v-if="exporting" class="mr-50"></b-spinner>
                            <feather-icon v-else icon="DownloadIcon" class="mr-50" />
                            Excel
                        </button>
                    </div>
                </div>
            </div>
            <div class="mx-1">
                <div class="row">
                    <div class="col-auto mb-1">
                        <div class="d-flex px-50 py-25 bg-light-success rounded align-items-center font-weight-bolder">
                            <span class="material-icons-outlined d-block mr-50">check_circle</span>
                            Yüklendi
                        </div>
                    </div>
                    <div class="col-auto mb-1">
                        <div class="d-flex px-50 py-25 bg-light-warning rounded align-items-center font-weight-bolder">
                            <span class="material-icons-outlined d-block mr-50">cancel</span>
                            Eksik / Yüklenmedi
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive mb-0 sicil-sticky-table">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th class="sticky-col-personel">Personel</th>
                            <th class="text-center sticky-col-status">Durum</th>
                            <th
                                v-for="(t, i) in titles"
                                class="text-nowrap text-center"
                                :class="{ 'text-muted bg-muted-soft': isIzinFormu(t) }"
                                v-b-tooltip.noninteractive.hover.bottom
                                :title="$safe(t, 'FileName')"
                                :key="i"
                            >
                                {{ $safe(t, "Index") }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="($safe(datas, 'AllEmployees.Data') || []).length == 0">
                            <tr>
                                <td colspan="1000" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </template>
                        <template v-for="(v, i) in $safe(datas, 'AllEmployees.Data') || []">
                            <tr :key="i">
                                <td class="text-nowrap sticky-col-personel">{{ $safe(v, "EmployeeFullName") }}</td>
                                <td class="text-center sticky-col-status">
                                    <span
                                        v-if="employeeComplete(v)"
                                        class="material-icons-outlined text-success d-block"
                                        v-b-tooltip.noninteractive.hover.right
                                        title="Tamamlandı"
                                    >task_alt</span>
                                    <span
                                        v-else
                                        class="material-icons-outlined text-danger d-block"
                                        v-b-tooltip.noninteractive.hover.right
                                        :title="employeeMissingTooltip(v)"
                                    >error_outline</span>
                                </td>
                                <td
                                    class="border-left text-center"
                                    :class="{ 'bg-muted-soft': isIzinFormu(t) }"
                                    v-for="(t, j) in titles"
                                    :key="j"
                                >
                                    <span
                                        v-if="getStatus(v, t.Index)"
                                        class="material-icons-outlined d-block"
                                        :class="isIzinFormu(t) ? 'text-secondary' : 'text-success'"
                                        v-on:click="downloadFile(v, t)"
                                        v-b-tooltip.noninteractive.hover.bottom
                                        :title="`${$safe(t, 'FileName')} — İndir`"
                                        style="cursor: pointer;"
                                    >check_circle</span>
                                    <span
                                        v-else
                                        class="material-icons-outlined d-block"
                                        :class="isIzinFormu(t) ? 'text-secondary' : 'text-warning'"
                                    >cancel</span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="px-75 mb-1 pt-1 border-top" v-if="count > 0">
                <div class="row justify-content-md-between justify-content-center">
                    <div class="col-auto mb-1 mb-md-0">
                        <div class="d-flex align-items-center text-nowrap">
                            Toplam {{ count || 0 }} kayıt arasından
                            <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                <option v-for="pp in perPages" :key="pp" :value="pp">{{ pp }}</option>
                            </select>
                            gösteriliyor.
                        </div>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <b-pagination class="mb-0" v-model="page" :total-rows="count || 0" :per-page="perPage"></b-pagination>
                    </div>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BPagination, BOverlay, BSpinner, VBTooltip } from "bootstrap-vue";
import SystemDataApi from "@/api/system-data";
import CompanyApi from "@/api/company";
import moment from "moment";
import EmployeeOperationsApi from "@/api/employee-operations";
import Additional from "@/utilities/additional";
import xlsx from "json-as-xlsx";

export default {
    components: {
        BCard,
        BOverlay,
        BPagination,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            donem: {
                year: moment().year(),
                month: moment().month() + 1,
            },
            page: 1,
            perPage: 10,
            perPages: [10, 20, 30, 40, 50, 100],
            count: 0,
            years: [],
            datas: {},
            getting: false,
            exporting: false,
            months: [
                { index: 1, name: "Ocak" },
                { index: 2, name: "Şubat" },
                { index: 3, name: "Mart" },
                { index: 4, name: "Nisan" },
                { index: 5, name: "Mayıs" },
                { index: 6, name: "Haziran" },
                { index: 7, name: "Temmuz" },
                { index: 8, name: "Ağustos" },
                { index: 9, name: "Eylül" },
                { index: 10, name: "Ekim" },
                { index: 11, name: "Kasım" },
                { index: 12, name: "Aralık" },
            ],
            branches: [],
            sbranches: [],
            collarStatuses: [],
            branch: null,
            branchType: "S",
            sbranch: null,
            collarStatus: null,
            search: null,
        };
    },
    watch: {
        page(oldV, newV) {
            if (oldV && newV && oldV != newV) {
                this.get();
            }
        },
        perPage(oldV, newV) {
            if (oldV && newV && oldV != newV) {
                this.get();
            }
        },
    },
    mounted() {
        this.configureYears();
        this.getBranches();
        this.getSBranches();
        this.getCollarStatuses();
    },
    methods: {
        buildRequest(skip, take) {
            return {
                BranchId: this.branchType == "O" ? this.branch?.Id || null : this.sbranch?.Id || null,
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
                PaginateRequest: {
                    IsAscending: true,
                    OrderColumnName: "",
                    QueryParam: this.search,
                    Skip: skip,
                    Take: take,
                },
            };
        },
        get() {
            this.getting = true;
            EmployeeOperationsApi.GetSicilDosyalariReport(this.buildRequest(this.page, this.perPage))
                .then((res) => {
                    if (res.data.Success) {
                        this.datas = res.data.Data || {};
                        this.count = this.$safe(this.datas, "AllEmployees.TotalCount") || 0;
                    }
                    this.getting = false;
                })
                .catch(() => {
                    this.getting = false;
                });
        },
        getBranches() {
            CompanyApi.Branch.ListByCode("O").then((res) => {
                this.branches = res.data.Data;
            });
        },
        getSBranches() {
            CompanyApi.Branch.ListByCode("S").then((res) => {
                this.sbranches = res.data.Data;
            });
        },
        getCollarStatuses() {
            SystemDataApi.CollarStatus().then((res) => {
                this.collarStatuses = res.data.Data?.filter((s) => s.Code != "-");
            });
        },
        configureYears() {
            let years = [];
            let year = moment().add(1, "year").format("YYYY");
            let firstYear = 1900;
            while (firstYear <= year) {
                years.push(firstYear++);
            }
            this.years = years.reverse();
        },
        getStatus(employee, index) {
            const file = (employee.DocumentsOfEmployee || []).find((d) => d.Index == index);
            return file ? file.IsUpload : false;
        },
        isIzinFormu(doc) {
            const name = (doc?.FileName || "").toLocaleLowerCase("tr-TR");
            return name.includes("izin formu") || name.includes("i̇zin formu");
        },
        mainDocs(employee) {
            const ts = this.titles || [];
            const izinIndexes = new Set(ts.filter((t) => this.isIzinFormu(t)).map((t) => t.Index));
            return (employee.DocumentsOfEmployee || []).filter((d) => !izinIndexes.has(d.Index));
        },
        employeeComplete(employee) {
            const mains = this.mainDocs(employee);
            if (!mains.length) return false;
            return mains.every((d) => d.IsUpload);
        },
        employeeMissingTooltip(employee) {
            const mains = this.mainDocs(employee);
            const missing = mains.filter((d) => !d.IsUpload).length;
            return `Eksik belge: ${missing} / ${mains.length}`;
        },
        async downloadFile(employee, doc) {
            try {
                this.getting = true;
                const res = await EmployeeOperationsApi.Employee.EmployeeSicilBelge.List(employee.EmployeeId);
                const items = res?.data?.Data || [];
                const target = (doc?.FileName || "").toLocaleLowerCase("tr-TR").trim();
                let match = items.find((it) => (it.Name || "").toLocaleLowerCase("tr-TR").trim() === target);
                if (!match) {
                    match = items.find((it) => (it.Name || "").toLocaleLowerCase("tr-TR").includes(target));
                }
                if (!match || !match.ApiFilePath) {
                    this.$toast?.warning?.("İndirilecek dosya bulunamadı.");
                    this.getting = false;
                    return;
                }
                const ext = match.ApiFilePath.split(".").pop();
                const fileName = `${match.Name}.${ext}`;
                const blob = await Additional.GetBlobFile(match.ApiFilePath);
                Additional.DownloadFile(blob.data, fileName);
                this.getting = false;
            } catch (err) {
                this.getting = false;
                this.$result?.(null, err);
            }
        },
        async exportToExcel() {
            if (this.collarStatus == null) return;
            this.exporting = true;
            try {
                const res = await EmployeeOperationsApi.GetSicilDosyalariReport(this.buildRequest(1, 999999));
                if (!res.data.Success) {
                    this.exporting = false;
                    return;
                }
                const data = res.data.Data || {};
                const allTitles = ((data.DocumentTypes || []).slice()).sort((a, b) => a.Index - b.Index);
                const employees = data.AllEmployees?.Data || [];

                const columns = [
                    { label: "Personel", value: "EmployeeFullName" },
                    { label: "Durum", value: "Durum" },
                ];
                allTitles.forEach((t) => {
                    const label = this.isIzinFormu(t)
                        ? `${t.Index} - ${t.FileName} (Asıl sicil belgesi değil)`
                        : `${t.Index} - ${t.FileName}`;
                    columns.push({ label, value: `doc_${t.Index}` });
                });

                const content = employees.map((emp) => {
                    const row = {
                        EmployeeFullName: emp.EmployeeFullName || "",
                        Durum: this.employeeComplete(emp) ? "Tamamlandı" : "Eksik",
                    };
                    allTitles.forEach((t) => {
                        row[`doc_${t.Index}`] = this.getStatus(emp, t.Index) ? "Yüklendi" : "Eksik";
                    });
                    return row;
                });

                const fileName = `Sicil_Dosyalari_${this.collarStatus?.Name || ""}_${moment().format("YYYYMMDD_HHmm")}`;
                xlsx(
                    [{ sheet: "Sicil Dosyaları", columns, content }],
                    { fileName, extraLength: 3, writeMode: "writeFile" }
                );
            } catch (err) {
                this.$result?.(null, err);
            } finally {
                this.exporting = false;
            }
        },
    },
    computed: {
        titles() {
            return (this.$safe(this.datas, "DocumentTypes") || []).slice().sort((a, b) => a.Index - b.Index);
        },
    },
};
</script>

<style scoped>
.sicil-sticky-table {
    max-height: calc(100vh - 320px);
    overflow: auto;
}
.sicil-sticky-table thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #f3f2f7;
}
.sicil-sticky-table thead th.sticky-col-personel {
    left: 0;
    z-index: 5;
}
.sicil-sticky-table thead th.sticky-col-status {
    left: 220px;
    z-index: 5;
}
.sicil-sticky-table tbody td.sticky-col-personel {
    position: sticky;
    left: 0;
    background-color: #ffffff;
    z-index: 1;
    min-width: 220px;
    max-width: 220px;
}
.sicil-sticky-table tbody td.sticky-col-status {
    position: sticky;
    left: 220px;
    background-color: #ffffff;
    z-index: 1;
}
.sicil-sticky-table thead th.sticky-col-personel,
.sicil-sticky-table thead th.sticky-col-status {
    position: sticky;
    top: 0;
}
.bg-muted-soft {
    background-color: #f1f1f1 !important;
}
.dark-layout .sicil-sticky-table thead th {
    background-color: #343d55;
}
.dark-layout .sicil-sticky-table tbody td.sticky-col-personel,
.dark-layout .sicil-sticky-table tbody td.sticky-col-status {
    background-color: #283046;
}
.dark-layout .bg-muted-soft {
    background-color: #3b4253 !important;
}
</style>
